import type { Dayjs } from 'dayjs';
import type { TaskPriority } from '../../tasks/types';

export interface CloseWonScheduleFormValues {
  scheduleNext?: boolean;
  nextDueDate?: Dayjs;
  nextTitle?: string;
  nextDescription?: string;
  nextPriority?: TaskPriority;
}

export function buildCloseWonSchedulePayload(values: CloseWonScheduleFormValues) {
  return {
    scheduleNext: values.scheduleNext ?? false,
    nextDueDate:
      values.scheduleNext && values.nextDueDate
        ? values.nextDueDate.format('YYYY-MM-DD')
        : undefined,
    nextTitle: values.scheduleNext ? values.nextTitle : undefined,
    nextDescription: values.scheduleNext ? values.nextDescription : undefined,
    nextPriority: values.scheduleNext ? values.nextPriority : undefined,
  };
}
